<template>
    <div class="data-view">
        <div class="border-view">
            <Map ref="map"></Map>
            <h1>728产业港数据监控大屏</h1>

            <div class="content">
                <div class="left">
                    <DataItem title="交易额统计">
                        <VolumeStatistics ref="volumeStatistics"></VolumeStatistics>
                    </DataItem>
                    <DataItem title="Amazon/OZON交易额统计">
                        <OzonAmzStatistics ref="ozonAmzStatistics"></OzonAmzStatistics>
                    </DataItem>
                    <DataItem title="学员交易额日榜TOP5">
                        <StudentStatistics ref="studentStatistics"></StudentStatistics>
                    </DataItem>

                </div>
                <div class="center">
                    <div class="center-top">
                        <BgDataItem v-for="item in bigDataTop" :decimals="item.decimals" :separator="item.separator"
                                    :suffix="item.suffix" :title="item.title"
                                    :value="item.value"></BgDataItem>
                    </div>
                    <div class="center-bottom">
                        <BgDataItem v-for="item in bigDataBottom" :decimals="item.decimals" :separator="item.separator"
                                    :suffix="item.suffix" :title="item.title"
                                    :value="item.value"></BgDataItem>

                    </div>
                </div>
                <div class="right">
                    <DataItem title="实时GMV">
                        <GmvStatistics ref="gmvStatistics"></GmvStatistics>
                    </DataItem>
                    <DataItem title="学员交易额总榜TOP10">
                        <StudentTopStatistics ref="studentTopStatistics"></StudentTopStatistics>
                    </DataItem>
                    <DataItem title="运营老师排行榜">
                        <div style="width: 100%;height: 100%;padding: 5px">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>姓名</th>
                                    <th>辅导人数</th>
                                    <th>总交易额</th>
                                    <th>人均交易额</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in operate_top_5">
                                    <td>
                                        <span v-if="item.operate">{{ item.operate.name }}</span>
                                    </td>
                                    <td>{{ item.user_num || 1 }}</td>
                                    <td>{{ item.order_amount }}</td>
                                    <td>{{ (item.order_amount / (item.user_num || 1)).toFixed(2) }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </DataItem>
                </div>
            </div>
            <DataViewFooter ref="footer"></DataViewFooter>
        </div>
    </div>
</template>

<script>
import DataViewFooter from "@/components/data-view-footer";
import Map from "@/components/map";
import DataItem from "@/components/data-item";
import BgDataItem from "@/components/bg-data-item";
import {bigDataBottom, bigDataTop} from "@/assets/js/methods";
import VolumeStatistics from "@/components/volume-statistics";
import OzonAmzStatistics from "@/components/ozon-amz-statistics";
import StudentStatistics from "@/components/student-statistics";
import GmvStatistics from "@/components/gmv-statistics";
import axios from "@/assets/js/axios";
import {country_list} from "@/assets/js/methods";
import {getDays} from "@/assets/js/get-days";
import {getVolumeStatisticsConfig} from "@/assets/js/getVolumeStatisticsConfig";
import {getOzonAmzConfig} from "@/assets/js/getOzonAmzConfig";
import {getStudentConfig} from "@/assets/js/getstudentConfig";
import StudentTopStatistics from "@/components/student-top-statistics";
import {mainLoop, mainTask} from "@/assets/js/sound-play";

export default {
	name: "data-view",
	components: {
		DataViewFooter,
		Map,
		DataItem,
		BgDataItem,
		VolumeStatistics,
		OzonAmzStatistics,
		StudentStatistics,
		GmvStatistics,
		StudentTopStatistics
	},
	data() {
		return {
			bigDataTop, bigDataBottom, operate_top_5: [], n: 1, timer: null,

		}
	},
	methods: {
		initData() {
			axios.get('api/order/order-view').then(res => {

				const {data} = res
				if (!data) {
					return
				}
				const {
					country_sum = [],
					order_sum = {},
					user_sum,
					oem_sum,
					market_sum,
					start_date, user_today_5, lastest_orders, operate_top_5,
					order_30_chart, gmv_today, gmv_max, user_top_10
				} = data.data
				const days = getDays(start_date)
				this.$refs.footer.setDays(days)
				const {order_amount, order_num} = order_sum
				const bigDataTopValues = [order_amount, order_num, oem_sum]
				const bigDataBottomValues = [user_sum, market_sum]
				this.bigDataTop = this.bigDataTop.map((item, index) => {
					item.value = Number(bigDataTopValues[index]) * this.n
					return item
				})
				this.bigDataBottom = this.bigDataBottom.map((item, index) => {
					item.value = Number(bigDataBottomValues[index]) * this.n
					return item
				})
				let country_list_data = []
				country_list.forEach(item => {
					const {country_code} = item
					const country = country_sum.find(i => i.country_code === country_code)
					if (country) {
						country_list_data.push({
							...item,
							...country
						})
					}

				})
				this.operate_top_5 = operate_top_5
				this.$refs.map.setCountryList(country_list_data)
				this.$refs.volumeStatistics.setConfig(getVolumeStatisticsConfig(order_30_chart))
				this.$refs.ozonAmzStatistics.setConfig(getOzonAmzConfig(order_30_chart))
				this.$refs.studentStatistics.setConfig(getStudentConfig(user_today_5))
				this.$refs.studentTopStatistics.setConfig(getStudentConfig(user_top_10))
				this.$refs.studentStatistics.setOrders(lastest_orders.filter(item => item.user).map(item => {
					const name = item.user.name.replace(/\d+/g, '')
					if (name) {
						item.user.name = name.substring(0, 3)
					} else {
						item.user.name = item.user.name.substring(0, 3)
					}

					return item
				}))
				this.$refs.gmvStatistics.setConfig({
					gmv_today: gmv_today.order_amount * 1, gmv_max: gmv_max.order_amount
				})
				//setInterval(mainLoop, 10 * 60 * 1000);

// 首次运行立即执行
				//;
			}).catch(e => {

			})
		}


	},
	mounted() {

		this.initData()
		clearInterval(this.timer)
		this.timer = setInterval(this.initData, 6e4)
	},
	beforeDestroy() {
		clearInterval(this.timer)
	}

}
</script>

<style lang="less" scoped>
.table {
  color: #adaaa2;
  font-size: .36rem;
  position: relative;
  width: 100%;
  height: 100%;
  //background: #24241e;
  td, th {
    border: 1px solid transparent;
    background: #24241e;
    text-align: center;
  }
}


</style>
